import { TemplateParamsPlugin } from "/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/nuxt/node_modules/@unhead/vue/dist/plugins.mjs";
export default {
  disableDefaults: true,
  plugins: [TemplateParamsPlugin],
}